// Специфікація МД для складання ПН: митна ціна позиції в гривні разом із митом — частка бази ПДВ товару
// (митна вартість гр. 45 + мито, decisions.md п. 28), розподілена між позиціями пропорційно фактурній вартості
// (кількість × ціна у валюті; якщо цін немає — порівну), поділена на кількість. Так само рахує «Рух».
// Рядки для вставлення в майстер ПН: назва · код УКТ ЗЕД · 1 (імпорт) · одиниця · кількість · ціна (lib/pn/paste.js)
import { normUnit } from "../units.js";

const r2 = (v) => Math.round(v * 100) / 100;
const dec = (v, max = 2) => Number(v).toLocaleString("uk-UA", { useGrouping: false, maximumFractionDigits: max });

// «Antenna … -15 шт.;» → «Antenna …»: хвіст прибираємо, лише якщо число в ньому — кількість цієї позиції
export function cleanName(name, qty) {
  const s = String(name ?? "").trim();
  // Хвіст — «-<число> <одиниця>[.][;]»: одиниця обов'язкова, щоб «170-225» (діапазон) не прийняти за кількість
  const m = s.match(/^(.*?)[\s,]*-\s*(\d+(?:[.,]\d+)?)\s+[^\s\d;.]+\.?\s*;?\s*$/);
  return m && Number(m[2].replace(",", ".")) === Number(qty) && m[1].trim() ? m[1].trim() : s.replace(/;\s*$/, "");
}

// goods — товар МД з customs_value (база ПДВ, грн) і positions [{ name, qty, unit, price }]
export function positionsUah(goods) {
  const pos = goods.positions || [];
  const base = Number(goods.customs_value) || 0;
  const weights = pos.map((p) => (Number(p.qty) || 0) * (Number(p.price) || 0));
  const tot = weights.reduce((a, w) => a + w, 0);
  let left = r2(base);
  return pos.map((p, i) => {
    // Остання позиція забирає залишок округлення — сума позицій = митна вартість товару до копійки
    const value = i === pos.length - 1 ? r2(left) : r2(base * (tot > 0 ? weights[i] / tot : 1 / pos.length));
    left -= value;
    const qty = Number(p.qty) || 0;
    return { ...p, unit: normUnit(p.unit), value, priceUah: qty > 0 ? r2(value / qty) : null };
  });
}

// Ціна продажу з націнкою, % (0 — митна ціна як є), до копійки
export const withMarkup = (price, markup = 0) => (price == null ? null : r2(price * (1 + (Number(markup) || 0) / 100)));

// Рядки TSV для «Вставити з таблиці» в майстрі ПН; markup — націнка до митної ціни, %
export function pnRows(goodsList, { markup = 0 } = {}) {
  return goodsList.flatMap((g) => positionsUah(g).filter((p) => Number(p.qty) > 0).map((p) =>
    [cleanName(p.name, p.qty), g.uktzed || "", "1", p.unit || "шт", dec(p.qty, 3), dec(withMarkup(p.priceUah, markup))].join("\t")));
}
